import React from 'react';
import { Shield, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#060a14] border-t border-slate-800 py-8 md:py-12 px-3 md:px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-69">
        <div className="flex items-center gap-1.5 text-white font-bold tracking-widest uppercase mb-4 md:mb-6 text-sm md:text-lg" data-id="element-70">
          <Shield className="w-4 h-4 md:w-6 md:h-6 text-blue-400" data-id="element-71" />
          DIGITALPREMIUM™
        </div>

        <p className="text-slate-400 text-sm md:text-lg mb-6 md:mb-10 max-w-md" data-id="element-72">
          Porque hoy proteger a tus hijos también es entender el mundo digital.
        </p>

        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6 mb-8 md:mb-12 text-slate-300 text-xs md:text-base" data-id="element-73">
          <a href="mailto:ayudadigitalpremium@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-74">
            <Mail className="w-4 h-4 md:w-5 md:h-5" data-id="element-75" />{' '}
            ayudadigitalpremium@gmail.com
          </a>
          <span className="hidden md:block text-slate-700" data-id="element-76">•</span>
          <a href="https://digitalpremium.online" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-77">
            <Globe className="w-4 h-4 md:w-5 md:h-5" data-id="element-78" /> digitalpremium.online
          </a>
        </div>

        <p className="text-slate-500 text-[11px] md:text-sm" data-id="element-79">
          © DigitalPremium 2026 Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}